module.exports = __webpack_public_path__ + "packs/media/images/logo-7999c76eef958bfc3b790ad22a45baf7.png";